import Axios from '@/services/axios'
import msg from '@/common/msg'
import * as code from '@/common/code'

export default {
  getDescriptions () {
    return new Promise((resolve, reject) => {
      Axios.get(
        '/Delivery/descriptions',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  register (params) {
    return new Promise((resolve, reject) => {
      Axios.post(
        '/Delivery/register',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  destroyRequest (params) {
    return new Promise((resolve, reject) => {
      Axios.post(
        '/Delivery/destroy-request',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  updateShippingInfoRequest (params) {
    return new Promise((resolve, reject) => {
      Axios.post(
        '/Delivery/update-shipping-info-request',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getLabelPdf (params) {
    let responseType = 'blob'
    return new Promise((resolve, reject) => {
      Axios.getByResponseType(
        '/Delivery/pdf',
        params,
        response => {
          if (!response || !response.data) {
            reject(msg.serverErr)
          }
          resolve(response.data)
        },
        error => {
          reject(error)
        },
        responseType
      )
    })
  },
  getDeliveryRequest (params) {
    return new Promise((resolve, reject) => {
      Axios.get(
        '/Delivery/request',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  postExport (params = {}, fileName = 'download.csv') {
    return new Promise((resolve, reject) => {
      Axios.downloadShiftJis(
        '/Delivery/export',
        params,
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        },
        fileName
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/deliveryservice.js